<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('information.qna.qna_add.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{ $t('information.title') }} > </span>
            <span class="middle_loc">{{ $t('information.qna.title') }} > </span>
            <span class="back_loc">{{ $t('common.common.new') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper">
        <ValidationObserver ref="qnaAdd">
          <v-form v-model="qnaAddValid">
            <v-flex class="inner_basic_wrap type2 my_app_tabs_data">
              <v-row class="board_views ma-0">
                <v-col cols="12" class="pa-0">
                  <table class="free__type__table">
                    <tbody>
                      <tr>
                        <td :class="{ 'text-left' : !this.$vuetify.rtl, 'text-right' : this.$vuetify.rtl}">
                          <h2 class="m_title">{{ $t('information.qna.qna_add.fields.title') }}<i>*</i></h2>
                          <div class="pa-20">
                            <div class="input_text_type_basic wp100">
                              <ValidationProvider v-slot="{ errors }" :name="$t('information.qna.qna_add.fields.title')" :rules="{required: true}">
                                <v-text-field
                                  dense
                                  outlined
                                  clearable
                                  maxlength="1024"
                                  class="ft-size12 login_text_field"
                                  style="height:40px;"
                                  :placeholder="$t('information.qna.qna_add.fields.title')"
                                  v-model="addQna.subject"
                                  :error-messages="errors"
                                >
                                </v-text-field>
                              </ValidationProvider>
                            </div>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td :class="{ 'text-left' : !this.$vuetify.rtl, 'text-right' : this.$vuetify.rtl}">
                          <h2 class="m_title">{{ $t('information.qna.qna_add.fields.attachment') }}</h2>
                          <div class="pa-20">
                            <div class="input_text_type_basic file_type wp50 fileForm">
                              <v-file-input
                                dense
                                outlined
                                hide-details
                                ref="uploadFile"
                                class="ft-size12"
                                :prepend-icon="$t('common.common.select_file')"
                                :placeholder="$t('information.qna.qna_add.fields.no_files_selected')"
                                v-model="selectedFile"
                                clearable
                                @click:clear="selectedFile = null"
                              >
                              </v-file-input>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td :class="{ 'text-left' : !this.$vuetify.rtl, 'text-right' : this.$vuetify.rtl}">
                          <h2 class="m_title">{{ $t('information.qna.qna_add.fields.content') }}</h2>
                          <div class="pa-20">
                            <div class="pa-20 pt-0" v-if="this.addQna.group_nbr > 0">
                              <v-row>
                                <v-col class="ft-size12" cols="12">
                                  <v-chip class="ft-size12 chp__cc" style="width:90px;" outlined color="#a21b29">{{$t('information.qna.fields.title')}}</v-chip>
                                  <div :class="(viewOrgData.question_lang_type_code === '2203') ? 'mt-15 text-right':'mt-15 text-left'">{{ viewOrgData.subject }}</div>
                                </v-col>

                                <v-col cols="12" class="ft-size12">
                                  <v-chip outlined color="#747474" style="width:90px;" class="chp__cc">{{$t('information.qna.qna_add.fields.content')}}</v-chip>
                                  <v-btn icon class="attach__mt ml-5 mr-5" v-if="viewOrgData.attached_file_key">
                                    <a style="text-decoration:none" :href="downLoadUrl + viewOrgData.attached_file_key">
                                      <v-icon color="#a01c2a">mdi-email</v-icon>
                                      <v-icon color="#fff" class="inner_icon">mdi-paperclip</v-icon>
                                    </a>
                                  </v-btn>
                                  <div :class="(viewOrgData.question_lang_type_code === '2203') ? 'mt-15 text-right':'mt-15 text-left'" v-html="viewOrgData.question_content"></div>
                                </v-col>
                                <v-col cols="12" class="ft-size12" v-if="viewOrgData.answer_content">
                                  <v-chip dark color="#a21b29" style="width:90px;" class="chp__cc">{{$t('information.qna.qna_view.fields.answer')}}</v-chip>
                                  <v-btn icon class="attach__mt ml-5 mr-5" v-if="viewOrgData.answer_file_key">
                                    <a style="text-decoration:none" :href="downLoadUrl + viewOrgData.answer_file_key">
                                      <v-icon color="#a01c2a">mdi-email</v-icon>
                                      <v-icon color="#fff" class="inner_icon">mdi-paperclip</v-icon>
                                    </a>
                                  </v-btn>
                                  <div :class="(viewOrgData.answer_lang_type_code === '2203') ? 'mt-15 text-right':'mt-15 text-left'" v-html="viewOrgData.answer_content"></div>
                                </v-col>
                              </v-row>
                            </div>

                            <ValidationProvider v-slot="{ errors }" :rules="{required: true}">
                              <ckeditor v-model="addQna.question_content" :config.sync="editorConfig" ref="ckeditor"></ckeditor>
                              <span class="ft-size12" style="color:#ff5252 !important;">{{ errors[0] }}</span>
                            </ValidationProvider>
                          </div>

                        </td>
                      </tr>
                      <tr>
                        <td :class="{ 'text-left' : !this.$vuetify.rtl, 'text-right' : this.$vuetify.rtl}" style="height:auto;">
                          <h2 class="m_title">{{ $t('information.qna.qna_add.fields.application_no') }}</h2>
                          <div class="app__qna__content__wrap">
                            <SearchApplication
                              :applicant_show_yn.sync="applicant_show_yn"
                              service_type_code="6412"
                              @success="fnSuccessChk"
                              @change="fnChagneApp"
                              class="app__qna__content"
                            />
                          </div>
                        </td>

                      </tr>
                    </tbody>
                  </table>
                </v-col>
              </v-row>

              <v-row class="ma-0 mt-10">
                <v-col cols="12" class="d-flex pa-0">
                  <v-spacer></v-spacer>
                  <v-btn
                    dense
                    height="50"
                    width="150"
                    dark
                    color="#2a58ad"
                    class="capitalize btn_basic br_none"
                    @click="fnAddQna()"
                  >
                    {{ $t('information.qna.qna_add.fields.submit') }}
                  </v-btn>
                </v-col>
              </v-row>

            </v-flex>
          </v-form>
        </ValidationObserver>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import { ckeditorConfig } from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import store from '@/store'
import SearchApplication from '@/components/layout/SearchApplicationQna'

export default {
  name: 'QnaAdd',
  components :{
    ValidationObserver,
    ValidationProvider,
    SearchApplication
  },
  data(){
    return {
       editorConfig: {
        toolbar: ckeditorConfig.toolbar,
        language: store.state.api.language,
        height: 500
      },
      qnaAddValid : true,

      selectedFile : null,

      addQna : {
        subject : '',
        question_content : '',
        question_lang_type_code: (this.$vuetify.rtl) ? '2203':'2202',
        attached_file_key : '',
        application_seq : '', // 나중에 추가
        answer_status_type_code : '6601', //고정
        group_nbr : 0
      },

      viewOrgData: {
        subject: '',
        question_content: '',
        question_lang_type_code: '',
        answer_content: '',
        answer_lang_type_code: '',
        attached_file_key: '',
        attached_file_ext: '',
        answer_file_key: '',
        answer_file_ext: ''
      },

      applicant_show_yn : true,
      downLoadUrl : process.env.VUE_APP_BASE_URL + '/file/download/'
    }
  },
  created(){
    if(!utils.isNull(this.$route.params.group_nbr)){
      this.addQna.group_nbr = this.$route.params.group_nbr
      this.fnGetQnaDetailOrg()
    }
  },
  methods : {
    fnGetQnaDetailOrg() {
      requestApi({
        url: '/info/boards/' + this.addQna.group_nbr,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.viewOrgData.subject = res.data.subject
            this.viewOrgData.question_content = res.data.question_content
            this.viewOrgData.question_lang_type_code = res.data.question_lang_type_code
            this.viewOrgData.answer_content = res.data.answer_content
            this.viewOrgData.answer_lang_type_code = res.data.answer_lang_type_code
            this.viewOrgData.attached_file_key = res.data.attached_file_key
            this.viewOrgData.attached_file_ext = res.data.attached_file_ext
            this.viewOrgData.answer_file_key = res.data.answer_file_key
            this.viewOrgData.answer_file_ext = res.data.answer_file_ext
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetQnaDetailOrg()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnAddQna(){
      this.$refs.qnaAdd.validate().then((valid) => {
        if(valid){
          if(!utils.isNull(this.selectedFile)){
            let formData = new FormData()
            formData.append("file_data", this.selectedFile)

            requestApi({
              url: '/file/upload',
              method: 'POST',
              data: formData,
              headers : {"Content-Type":"multipart/form-data"},
              callback: (res) => {
                // 파일저장
                if (res.res_code === '200') {
                  this.addQna.attached_file_key = res.data.file_key
                  this.fnAddQnaContent()
                }else{
                  if (res.res_code === '401012') {
                    utils.setTokenRefresh().then(() => {
                      this.fnAddQna()
                    })
                  } else {
                    eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                  }
                }
              }
            })
          }else{
            this.fnAddQnaContent()
          }
        } else {
          //2020-11-03 : 첫번째 에러 항목으로 Focus 되도록 추가 수정 (vee-validate 3.0 기반)
          document.getElementsByClassName('error--text')[0].scrollIntoView(false)
        }
      })
    },
    fnAddQnaContent(){
      requestApi({
        url: '/info/boards',
        method: 'POST',
        data: this.addQna,
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.$t('common.message.add.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
            this.$router.replace({ path : '/information/qna'})
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnAddQnaContent()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnSuccessChk(chked_item){
      this.addQna.application_seq = chked_item.application.seq
    },
    fnChagneApp(){
      this.addQna.application_seq = null
    },
  }
}
</script>